import { styled } from '@mui/material'
import { Call as CallIcon, CallEnd as CallEndIcon } from '@mui/icons-material'
import { callService, useCallStorage, useCallStoragePvMeta } from '$logic/call'
import { t } from '$i18n'
import { ControlButton } from './control-button'
import { showErrorSnackbar } from '$comp/snackbars'
import {
  CallAction,
  reportCallActionFailure,
} from '$logic/analytics/reporters/call-action-failed'

const Container = styled('div')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 48px;
`

export function IncomingCallControls() {
  const { roomId } = useCallStorage()

  return (
    <Container>
      <ControlButton
        color="success"
        caption={t('call.accept')}
        icon={<CallIcon />}
        onClick={callService.acceptIncomingCall}
        onActionTimeout={timeOutMS => {
          showErrorSnackbar(t('snackbar.call.requestFailed'))
          reportCallActionFailure(
            CallAction.ACCEPT_INCOMING_CALL,
            'call',
            timeOutMS,
            {
              roomId,
            },
          )
        }}
      />

      <ControlButton
        color="error"
        caption={t('call.reject')}
        icon={<CallEndIcon />}
        onClick={callService.rejectIncomingCall}
        onActionTimeout={timeOutMS => {
          showErrorSnackbar(t('snackbar.call.requestFailed'))
          reportCallActionFailure(
            CallAction.REJECT_INCOMING_CALL,
            'call',
            timeOutMS,
            {
              roomId,
            },
          )
        }}
      />
    </Container>
  )
}
